module.exports = __webpack_public_path__ + "pc/img/publisher.dd3e12dc.png";